import React, { FC } from "react";
import { Divider as MuiDivider, DividerProps } from "@mui/material";

const Divider: FC<DividerProps> = (props) => <MuiDivider {...props} />;

export default Divider;
